import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add as AddIcon, Close as CloseIcon } from "@mui/icons-material";
import { Alert, Box, Chip, IconButton, Typography } from "@mui/material";
const FILTER_LABELS = {
    geography: "Geography",
    function: "Function",
    company: "Company",
    companyHeadquarters: "Company headquarters",
    jobTitle: "Job title",
    industry: "Industry",
    school: "School",
};
export const hasFailedFilters = (failedFilters) => {
    if (!failedFilters)
        return false;
    return Object.values(failedFilters).some((values) => values && values.length > 0);
};
export const FailedFiltersAlert = ({ failedFilters, onAddToKeywords, onDismiss, }) => {
    const failedFilterEntries = Object.entries(failedFilters).filter(([, values]) => values && values.length > 0);
    if (failedFilterEntries.length === 0) {
        return null;
    }
    return (_jsxs(Alert, Object.assign({ severity: "warning", sx: {
            mb: 2,
            "& .MuiAlert-message": {
                width: "100%",
            },
        }, action: _jsx(IconButton, Object.assign({ size: "small", onClick: onDismiss, "aria-label": "dismiss" }, { children: _jsx(CloseIcon, { fontSize: "small" }) })) }, { children: [_jsx(Typography, Object.assign({ variant: "body2", fontWeight: 500, sx: { mb: 1 } }, { children: "Some filters couldn't be matched and were skipped. Add them as keywords by clicking the chips below." })), failedFilterEntries.map(([filterType, values]) => (_jsxs(Box, Object.assign({ sx: { display: "flex", alignItems: "center", gap: 1, mb: 0.5, flexWrap: "wrap" } }, { children: [_jsxs(Typography, Object.assign({ variant: "body2", color: "text.secondary", sx: { minWidth: 120 } }, { children: [FILTER_LABELS[filterType], ":"] })), values.map((value) => (_jsx(Chip, { label: value, size: "small", icon: _jsx(AddIcon, { fontSize: "small" }), onClick: () => onAddToKeywords(value, filterType), sx: {
                            cursor: "pointer",
                            "&:hover": {
                                bgcolor: "warning.light",
                            },
                        } }, `${filterType}-${value}`)))] }), filterType)))] })));
};
